export default __webpack_public_path__ + "static/media/whoisbitcoinsatoshiupdated.002fb517.png";